import { swSettings } from "app/common/services/swSettings";
import { CellSite, IndexCell, TrafficShare } from "app/components/React/Table/cells";
import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { i18nFilter, translate } from "app/filters/i18nFilter";
import { CellSiteWithDropdown } from "app/pages/website-analysis/pages/components/CellSiteDropdown";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getFinalTransitionParamsToKeywordDetailPage } from "../utils";

import type { SELECTION_STATUS } from "./types";

const DEFAULT_INNER_SORT = "Share";
const DEFAULT_SORT_DIRECTION = "desc";
const DROP_DOWN_OPTIONS = [
    {
        get text() {
            return translate("search.pages.table.columns.explore");
        },
        onClick: (value: string) => {
            proNavigator.go(
                "organicsearch_websites_v2_traffic_keywords",
                getFinalTransitionParamsToKeywordDetailPage({ keyValue: value, searchType: "folder" }),
            );
        },
        icon: "keywords",
    },
];

export const SelectCellSite = () => {
    if (swSettings.user.hasSI && !swSettings.user.isSimilarWebUser) {
        return CellSite;
    }

    return CellSiteWithDropdown;
};

export const FoldersTableColumns = {
    getColumns: (selectionStatus: SELECTION_STATUS) => {
        const { selectable, tooltipKey } = selectionStatus;
        return [
            {
                fixed: true,
                cellComponent: (props) => (
                    <RowSelectionConsumer
                        {...props}
                        row={{ ...props.row, selectable, tooltipText: translate(tooltipKey) }}
                    />
                ),
                sortable: false,
                isResizable: false,
                width: 40,
                disableHeaderCellHover: true,
            },
            {
                fixed: true,
                cellComponent: IndexCell,
                disableHeaderCellHover: true,
                sortable: false,
                width: 40,
                isResizable: false,
            },
            {
                fixed: true,
                field: "Folder",
                get displayName() {
                    return translate("analysis.content.pop.folders.table.columns.folder.title");
                },
                get tooltip() {
                    return translate("analysis.common.content.pop.folders.tooltip");
                },
                cellComponent: SelectCellSite(),
                dropDownOptions: DROP_DOWN_OPTIONS,
                sortable: true,
                showTotalCount: true,
                groupable: true,
                width: 600,
            },
            {
                field: "Share",
                get displayName() {
                    return translate("analysis.content.pop.folders.table.columns.share.title");
                },
                type: "double",
                sortable: true,
                isSorted: true,
                cellComponent: TrafficShare,
                headerComponent: DefaultCellHeader,
                sortDirection: "desc",
                get tooltip() {
                    return translate("analysis.content.pop.folders.table.columns.share.title.tooltip");
                },
                minWidth: 108,
                visible: true,
            },
        ].map((col) => {
            const isSorted = col.field === DEFAULT_INNER_SORT;
            return {
                ...col,
                isSorted,
                sortDirection: DEFAULT_SORT_DIRECTION,
                isResizable: col.isResizable,
                visible: true,
            };
        });
    },
};
